import { handle } from 'redux-pack';
import { StripeStatus } from '../../../connection/integrations';
import { Action } from '../../../types/actions';
import { DISABLE_GOOGLE_ANALYTICS, GET_GOOGLE_ANALYTICS, INTEGRATIONS_STRIPE_CONTACT, INTEGRATIONS_STRIPE_STATUS, SET_GOOGLE_ANALYTICS } from '../../actions/admin/integrations';

export interface IntegrationsState {
	stripe: {
		loading: boolean
		status: StripeStatus,
		contact: string | null,
		setting_contact: boolean
	},
	googleAnalytics: {
		id: number;
		google_id: string;
		channel: number;
		status: number;
	} | null;
	loadingGoogleAnalytics: boolean;
}

const initialState: IntegrationsState = {
	stripe: {
		loading: false,
		status: StripeStatus.none,
		contact: null,
		setting_contact: false
	},
	googleAnalytics: null,
	loadingGoogleAnalytics: false
};

export default function IntegrationsReducer(state: IntegrationsState = initialState, action: Action): IntegrationsState {
	switch (action.type) {
		case INTEGRATIONS_STRIPE_STATUS: {
			return handle(state, action, {
				start: state => ({ ...state, stripe: { ...state.stripe, loading: true } }),
				success: state => ({
					...state,
					stripe: {
						...state.stripe,
						status: action.payload.stripe_status,
						contact: action.payload.primary_contact
					}
				}),
				finish: state => ({
					...state,
					stripe: {
						...state.stripe,
						loading: false
					}
				})
			});
		}
		case INTEGRATIONS_STRIPE_CONTACT: {
			return handle(state, action, {
				start: state => ({
					...state,
					stripe: {
						...state.stripe,
						setting_contact: true
					}
				}),
				success: state => ({
					...state,
					stripe: {
						...state.stripe,
						contact: action.payload.email
					}
				}),
				finish: state => ({
					...state,
					stripe: {
						...state.stripe,
						setting_contact: false
					}
				})
			});
		}
		case GET_GOOGLE_ANALYTICS: {
			return handle(state, action, {
				start: state => ({ ...state, loadingGoogleAnalytics: true }),
				finish: state => ({ ...state, loadingGoogleAnalytics: false }),
				success: state => {
					if (action.payload.not_found) {
						return ({ ...state, googleAnalytics: null });
					} else {
						return ({ ...state, googleAnalytics: action.payload });
					}
				}
			});
		}
		case SET_GOOGLE_ANALYTICS: {
			return handle(state, action, {
				start: state => ({ ...state, loadingGoogleAnalytics: true }),
				finish: state => ({ ...state, loadingGoogleAnalytics: false }),
				success: state => ({ ...state, googleAnalytics: action.payload })
			});
		}
		case DISABLE_GOOGLE_ANALYTICS: {
			return handle(state, action, {
				start: state => ({ ...state, loadingGoogleAnalytics: true }),
				finish: state => ({ ...state, loadingGoogleAnalytics: false }),
				success: state => ({ ...state, googleAnalytics: null })
			});
		}
		default: return state;
	}
}